import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const Logo = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <img src="/cafe-des-marches-logo-clair.png" alt="Le Café des Marchés" className="w-9 h-9 object-contain" data-testid="brand-logo" />
    <span className="font-display font-extrabold text-xl tracking-tight text-slate-900 whitespace-nowrap">
      Le Café des Marchés
    </span>
  </div>
);

export default function Navbar() {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else navigate(`/#${id}`);
  };

  return (
    <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link"><Logo /></Link>

        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-slate-600">
          <button onClick={() => scrollTo("fonctionnement")} className="hover:text-slate-900 transition-colors" data-testid="nav-how">Comment ça marche</button>
          <button onClick={() => scrollTo("secteurs")} className="hover:text-slate-900 transition-colors" data-testid="nav-sectors">Secteurs</button>
          <Link to="/secteurs" className="hover:text-slate-900 transition-colors" data-testid="nav-seo">Marchés par département</Link>
          <button onClick={() => scrollTo("tarifs")} className="hover:text-slate-900 transition-colors" data-testid="nav-pricing">Tarifs</button>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Button variant="ghost" onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-btn">Mon espace</Button>
              <Button variant="outline" onClick={logout} data-testid="nav-logout-btn">Déconnexion</Button>
            </>
          ) : (
            <>
              <Button variant="ghost" onClick={login} data-testid="nav-login-btn">Connexion</Button>
              <Button onClick={login} className="rounded-full" data-testid="nav-signup-btn">Commencer, 0€ aujourd'hui</Button>
            </>
          )}
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background px-5 py-4 flex flex-col gap-3">
          <button onClick={() => scrollTo("fonctionnement")} className="text-left py-2 text-slate-700">Comment ça marche</button>
          <button onClick={() => scrollTo("secteurs")} className="text-left py-2 text-slate-700">Secteurs</button>
          <Link to="/secteurs" className="text-left py-2 text-slate-700">Marchés par département</Link>
          <button onClick={() => scrollTo("tarifs")} className="text-left py-2 text-slate-700">Tarifs</button>
          {user ? (
            <>
              <Button onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-btn-m">Mon espace</Button>
              <Button variant="outline" onClick={logout}>Déconnexion</Button>
            </>
          ) : (
            <Button onClick={login} className="rounded-full" data-testid="nav-signup-btn-m">Commencer, 0€ aujourd'hui</Button>
          )}
        </div>
      )}
    </header>
  );
}
